import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';
import LoadingPage from '@components/LoadingPage';
import type { PrivateRouteProps } from '@root/src/Router.type';

const ComponentLoad = lazy(async () => await import('./component'));

const ArticlesPage: FC<PrivateRouteProps> = props => (
  <Suspense fallback={<LoadingPage />}>
    <ComponentLoad {...(props as any)} />
  </Suspense>
);

export default memo(ArticlesPage);
